import { createReducer, on } from '@ngrx/store';
import { UploadedFileData } from '../domain/uploaded-file';
import * as FileUploadActions from './file-upload.actions';

export const featureKey = 'cxbFileUpload';

export interface FeatureState {
  loading: boolean;
  uploadedFiles: UploadedFileData[];
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  loading: false,
  uploadedFiles: [],
};

export const reducer = createReducer(
  initialState,
  on(FileUploadActions.uploadCxBFile, FileUploadActions.deleteCxBFile, (state): FeatureState => ({ ...state, loading: true })),
  on(
    FileUploadActions.uploadCxBFileSuccess,
    (state, action): FeatureState => ({
      ...state,
      loading: false,
      uploadedFiles: state.uploadedFiles.includes(action.uploadedFileData)
        ? [...state.uploadedFiles]
        : [...state.uploadedFiles, action.uploadedFileData],
    })
  ),
  on(
    FileUploadActions.deleteCxBFileSuccess,
    (state, action): FeatureState => ({
      ...state,
      loading: false,
      uploadedFiles: [...state.uploadedFiles.filter((uploadedFile) => uploadedFile.id !== action.fileId)],
    })
  ),
  on(FileUploadActions.uploadCxBFileFail, FileUploadActions.deleteCxBFileFail, (state): FeatureState => ({ ...state, loading: false }))
);
